
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "VAS",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/VAS.vue